import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import { useAuthContext } from '../../../../contexts/authContext';

type Props = {
    title: string;
    onClick: any;
    startIcon?: JSX.Element | string | undefined;
    endIcon?: JSX.Element | string | undefined;
    sx?: object | undefined;
    fullWidth?: false | boolean;
    disabled?: false | boolean;
    loading?: false | boolean;
    loadingPosition?: 'start' | 'end' | 'center';
};

const LoadingButtonGeneral = ({
    title,
    onClick,
    startIcon,
    endIcon,
    sx,
    fullWidth,
    disabled,
    loading,
    loadingPosition,
}: Props) => {
    const { modeTheme } = useAuthContext();

    return (
        <>
            <LoadingButton
                loading={loading}
                type="submit"
                fullWidth={fullWidth}
                onClick={onClick}
                variant="contained"
                startIcon={startIcon !== undefined ? startIcon : null}
                endIcon={endIcon !== undefined ? endIcon : null}
                loadingPosition={loadingPosition}
                disabled={disabled}
                sx={sx}
            >
                <Typography
                    component="div"
                    sx={{
                        color:
                            modeTheme === 'darkMode'
                                ? 'primary.main'
                                : 'primary.contrastText',
                    }}
                >
                    {title}
                </Typography>
            </LoadingButton>
        </>
    );
};

export default LoadingButtonGeneral;
